import React, { useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { resetPassword, resetNewPassPage } from "../../actions/auth-action";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  Alert,
  Card,
} from "react-bootstrap";
import Header from "../common/Header";
import Footer from "../common/Footer";
import "./NewPass.scss";

const NewPass = (props) => {
  const { resetPassword, resetNewPassPage } = props;

  const [code, setCode] = useState("");
  const [newPass, setNewPass] = useState("");
  const [repeatPass, setRepeatPass] = useState("");

  const { resetPassStart, resetPassSuccess, resetPassError, tempEmail } =
    useSelector((state) => state.auth);
  const history = useHistory();

  useEffect(() => {
    if (resetPassSuccess) {
      setTimeout(() => {
        history.replace("/login");
      }, 300);
    }
  }, [resetPassSuccess]);

  useEffect(() => {
    resetNewPassPage();
    return () => {
      resetNewPassPage();
    };
  }, []);

  const clickReset = (e) => {
    e.preventDefault();
    resetPassword({
      email: tempEmail,
      otp: code,
      password: newPass,
      password_confirmation: repeatPass,
    });
  };

  return (
    <>
      <Header />
      <Container fluid>
        <Row className="justify-content-center mt-5 new-pass">
          <Col className="new-pass-col">
            <div className="p-4">
              <h6 className="header-text text-center">Reset Password</h6>
              <Form className="mt-5">
                <Form.Group className="ch-form">
                  <Form.Control
                    type="input"
                    placeholder="Reset code"
                    value={code}
                    onChange={(e) => setCode(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    type="password"
                    placeholder="New password"
                    value={newPass}
                    onChange={(e) => setNewPass(e.target.value)}
                  />
                </Form.Group>
                <Form.Group className="ch-form">
                  <Form.Control
                    type="password"
                    placeholder="Repeat password"
                    value={repeatPass}
                    onChange={(e) => setRepeatPass(e.target.value)}
                  />
                </Form.Group>
                <Button
                  type="submit"
                  onClick={clickReset}
                  className="ch-button mt-4"
                  variant="success"
                >
                  {resetPassStart ? "Updating..." : "Reset Password"}
                </Button>
                <Alert
                  show={resetPassSuccess || resetPassError != null}
                  variant={resetPassError ? "danger" : "success"}
                  className="mt-3"
                >
                  {" "}
                  {resetPassError || "Password has been changed!"}
                </Alert>
              </Form>
            </div>
          </Col>
        </Row>
        <Footer />
      </Container>
    </>
  );
};
export default connect(null, { resetPassword, resetNewPassPage })(NewPass);
